import {
    CREATESALESCHANNEL,
    GETSALESCHANNEL,
    UPDATESALESCHANNEL,
    DELETESALESCHANNEL,
  } from "../actions/types";
  
  const initialState = {
    salesChannelList: [],
    createSalesChannel: null,
    updateSalesChannel: null,
    deleteSalesChannel: null,
  };
  
  export default function (state = initialState, action) {
    switch (action.type) {
  
      case GETSALESCHANNEL:
        return {
          ...state,
          salesChannelList: action.payload.data,
        };
  
      case CREATESALESCHANNEL:
        return {
          ...state,
          createSalesChannel: action.payload,
        };
  
      case UPDATESALESCHANNEL:
        return {
          ...state,
          updateSalesChannel: action.payload,
        };
  
      case DELETESALESCHANNEL:
        return {
          ...state,
          deleteSalesChannel: action.payload,
        };
  
      default:
        return state;
    }
  }
  